import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";

import globalConstants from "constants/globalConstants";
import { preloadImage } from "modules/functions";
import MenuItem from "./MenuItem";
import ButtonPrimaryIcon from "components/buttons/ButtonPrimaryIcon";
import CompactMenuItem from "./CompactMenuItem";

import homeIcon from "assets/img/icons/menu-home.svg";
import discoverIcon from "assets/img/icons/menu-discover.svg";
import messagesIcon from "assets/img/icons/menu-messages.svg";
import postsIcon from "assets/img/icons/menu-posts.svg";
import referralsIcon from "assets/img/icons/menu-referrals.svg";
import walletIcon from "assets/img/icons/menu-wallet.svg";
import settingsIcon from "assets/img/icons/menu-settings.svg";
import homeCurrentIcon from "assets/img/icons/menu-home-current.svg";
import discoverCurrentIcon from "assets/img/icons/menu-discover-current.svg";
import messagesCurrentIcon from "assets/img/icons/menu-messages-current.svg";
import postsCurrentIcon from "assets/img/icons/menu-posts-current.svg";
import referralsCurrentIcon from "assets/img/icons/menu-referrals-current.svg";
import walletCurrentIcon from "assets/img/icons/menu-wallet-current.svg";
import settingsCurrentIcon from "assets/img/icons/menu-settings-current.svg";
import adPlanIcon from "assets/img/icons/menu-ad-plan.svg";
import adPlanCurrentIcon from "assets/img/icons/menu-ad-plan-current.svg";
import logoutIcon from "assets/img/icons/menu-logout.svg";
import plusIcon from "assets/img/icons/plus-sign.svg";
import plusWhiteIcon from "assets/img/icons/plus-sign-white.svg";
import trophyIcon from "assets/img/icons/trophy-icon.svg";
import trophyCurrentIcon from "assets/img/icons/trophy-icon-current.svg";
import helpIcon from "assets/img/icons/help-icon.svg";
import landingPagesIcon from "assets/img/icons/menu-landing-pages.svg";
import landingPagesCurrentIcon from "assets/img/icons/menu-landing-pages-current.svg";

const Menu = styled.div`
  margin-bottom: ${(props) => (props.tablet ? "40px" : "0")};

  display: flex;
  flex-direction: column;
`;

const ButtonWrap = styled.div`
  margin-top: ${(props) => (props.tablet ? "40px" : "60px")};
  margin-bottom: 5px;
  padding-left: ${(props) => (props.tablet ? "40px" : "0")};

  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.tablet ? "flex-start" : "stretch")};
`;

const CompactItems = styled.div`
  padding-left: ${(props) => (props.wide ? "27px" : "12px")};

  display: flex;
  align-items: center;
  gap: 2px;
`;

export default ({ unreadMessages, adPlan }) => {
  const navigate = useNavigate();

  const tabletScreen = useMediaQuery({
    query: `(max-width: ${globalConstants.switchTablet})`,
  });

  preloadImage(homeIcon);
  preloadImage(homeCurrentIcon);
  preloadImage(discoverIcon);
  preloadImage(discoverCurrentIcon);
  preloadImage(messagesIcon);
  preloadImage(messagesCurrentIcon);
  preloadImage(postsIcon);
  preloadImage(postsCurrentIcon);
  preloadImage(referralsIcon);
  preloadImage(referralsCurrentIcon);
  preloadImage(trophyIcon);
  preloadImage(trophyCurrentIcon);
  preloadImage(walletIcon);
  preloadImage(walletCurrentIcon);
  preloadImage(settingsIcon);
  preloadImage(settingsCurrentIcon);
  preloadImage(helpIcon);
  preloadImage(logoutIcon);
  preloadImage(plusWhiteIcon);

  return (
    <Menu tablet={tabletScreen ? 1 : 0}>
      <MenuItem to="/home" icon={homeIcon} iconCurrent={homeCurrentIcon}>
        Dashboard
      </MenuItem>
      <MenuItem
        to="/discover"
        icon={discoverIcon}
        iconCurrent={discoverCurrentIcon}
        emphasized={true}
      >
        Discover
      </MenuItem>
      <MenuItem
        to="/messages"
        icon={messagesIcon}
        iconCurrent={messagesCurrentIcon}
        dot={unreadMessages}
      >
        Messages
      </MenuItem>
      <MenuItem to="/posts" icon={postsIcon} iconCurrent={postsCurrentIcon}>
        Posts
      </MenuItem>
      <MenuItem
        to={adPlan > 0 ? "/ad-plan" : "/advertising-plans"}
        icon={adPlanIcon}
        iconCurrent={adPlanCurrentIcon}
      >
        Ad Plan
      </MenuItem>
      <MenuItem
        to="/marketing-tools"
        icon={landingPagesIcon}
        iconCurrent={landingPagesCurrentIcon}
        newIcon={1}
      >
        Landing Pages
      </MenuItem>
      <MenuItem
        to="/referrals"
        icon={referralsIcon}
        iconCurrent={referralsCurrentIcon}
      >
        Referrals
      </MenuItem>
      <MenuItem to="/contest" icon={trophyIcon} iconCurrent={trophyCurrentIcon}>
        Contest
      </MenuItem>
      <MenuItem to="/wallet" icon={walletIcon} iconCurrent={walletCurrentIcon}>
        Wallet
      </MenuItem>
      <CompactItems wide={tabletScreen ? 1 : 0}>
        <CompactMenuItem
          to="/settings"
          icon={settingsIcon}
          iconCurrent={settingsCurrentIcon}
        />
        <CompactMenuItem
          to="https://help.scalelup.com"
          icon={helpIcon}
          target="_blank"
        />
        <CompactMenuItem to="/logout" icon={logoutIcon} translate="1px" />
      </CompactItems>
      <ButtonWrap tablet={tabletScreen ? 1 : 0}>
        <ButtonPrimaryIcon
          icon={plusIcon}
          iconHover={plusWhiteIcon}
          onClick={() => {
            navigate("/modify-post");
          }}
        >
          Create Post
        </ButtonPrimaryIcon>
      </ButtonWrap>
    </Menu>
  );
};
